module.exports = __webpack_public_path__ + "static/media/ike_0.f1d25eec.png";